import type { ReactNode } from "react";
import { cx } from "./util";

export interface NavBarProps {
  /** Sub-bar text: round counter, phase name, player count. */
  subnav?: ReactNode;
  /** Right-hand nav words. Real buttons, styled as nav words. */
  actions?: ReactNode;
  className?: string;
}

/**
 * Carbon command bar + pale-sky subnav. Nav gold is reserved for nav words
 * and appears nowhere else in the app.
 */
export function NavBar({ subnav, actions, className }: NavBarProps) {
  return (
    <div className={cx("bd-nav", className)}>
      <nav className="navbar slab" aria-label="Main">
        <span className="logo-pill">BADLY&nbsp;DUBBED</span>
        <span className="grow" />
        {actions}
      </nav>
      {subnav ? (
        <div className="subnav t-label" role="status">
          {subnav}
        </div>
      ) : null}
    </div>
  );
}

/** A nav word. Anchor-looking, button-behaving. */
export function NavWord({
  onClick,
  children,
  disabled,
}: {
  onClick: () => void;
  children: ReactNode;
  disabled?: boolean;
}) {
  return (
    <button type="button" className="nav-word t-nav bd-navword" onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
}
